import {map, filter} from 'rxjs/operators';
import {Component, ElementRef, OnInit, OnDestroy, Renderer2} from '@angular/core';
import {LotteriesService} from '../../../../lotteries.service';
import * as globals from '../../../../settings';
import {NavigationEnd, Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {SubscriptionsService} from '../../../../_services/subscriptions.service';
import {UserService} from '../../../../_services/user.service';
import {CounterService} from '../../../../_services/counter.service';
import {Subscription} from 'rxjs';
import {IncomingdrawsService} from '../../../../_services/incomingdraws.service';
import {CurrencyService} from '../../../../_services/currency.service';
import {LanguageService} from '../../../../_services/language.service';

@Component({
  selector: 'app-lotteries-navigation',
  templateUrl: './lotteries-navigation.component.html',
  styleUrls: ['./lotteries-navigation.component.scss', './hamburger-navigation.component.scss']
})
export class LotteriesNavigationComponent implements OnInit, OnDestroy {
    isOpenedLotteries: boolean;
    isOpenedMyAcccount: boolean;
    isOpenedSupport: boolean;
    isOpenedLanguages: boolean;
    isClassVisible: boolean;
    openedBool: any;
    lotteries: any;
    lottery: any;
    powerball: any;
    euromillions: any;
    eurojackpot: any;
    megamillions: any;
    restLotteries: any;
    powerballLast: any;
    euromillionsLast: any;
    eurojackpotLast: any;
    megamillionsLast: any;
    powerballBundle: any;
    euromillionsBundle: any;
    eurojackpotBundle: any;
    megamillionsBundle: any;
    a6aus49Bundle: any;
    a6aus49Last: any;
    a6aus49: any;
    countryCode: any;
    showOffers: boolean;
    user: any;
    isMobile: any;
    language: any;
    loggedIn: boolean;
    isTablet: boolean;
    isLoadingButtonName: any;
    languageChange: any;
    showLang: any;
    isSafari: boolean;
    entriesLenght: any;
    countPlayNow: any;
    incomingDrawsSubscription: Subscription;
    changedCurrency: Subscription;
    currency: any;
    sortValues: any;
    selected_method_show_name: any;
    routerForNavbar: any;
    languageSwitcherReadyToShowMobile: boolean;
    brand = globals.brand;
    winaijalotto: any;
    winner: any;
    constructor(public lotteryService: LotteriesService,
                public subscriptionsService: SubscriptionsService,
                private router: Router,
                private translate: TranslateService,
                private renderer: Renderer2,
                public userService: UserService,
                public counterService: CounterService,
                public incomingDrawsService: IncomingdrawsService,
                public currencyService: CurrencyService,
                public languageService: LanguageService) {
        this.languageChange = this.subscriptionsService.getLanguage().subscribe( lang => {
            this.showLang =  lang;
        });

        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });
    }

    getIsLoading(name) {
      return name === this.isLoadingButtonName;
    }

    closeRegisterModal() {
      this.subscriptionsService.emitRegister(false);
      this.renderer.removeClass(document.body, 'modal-open');
      this.renderer.removeClass(document.body, 'modal-open-register');
      this.subscriptionsService.emitToggleContent(true);
    }

    ngOnInit() {

        this.isSafari = false;
        this.languageSwitcherReadyToShowMobile = false;

        const navigatorUa = navigator.userAgent.toLowerCase();
        if (navigatorUa.indexOf('safari') !== -1) {
          if (navigatorUa.indexOf('chrome') === -1) {
            this.isSafari = true;
          }
        }

        this.isTablet = false;
        const ua = navigator.userAgent;
        const touch = 'ontouchstart' in document.documentElement;
        const tablet = /Tablet|iPad/i.test(ua);
        if (touch || tablet) {
          this.isTablet = true;
        }

        this.powerball = [];
        this.euromillions = [];
        this.eurojackpot = [];
        this.megamillions = [];
        this.winner = [];
        this.winaijalotto = [];
        this.powerballLast = [];
        this.euromillionsLast = [];
        this.eurojackpotLast = [];
        this.megamillionsLast = [];
        this.powerballBundle = [];
        this.euromillionsBundle = [];
        this.eurojackpotBundle = [];
        this.megamillionsBundle = [];
        this.a6aus49Bundle = [];
        this.a6aus49Last = [];
        this.a6aus49 = [];
        this.countryCode = localStorage.getItem('country');
        this.getResults();
        this.openedBool = false;
        this.isClassVisible = false;
        this.waitForCC();
        const user = localStorage.getItem('playerDetails');
        if (user) {
          this.loggedIn = true;
        }
        this.language = localStorage.getItem('pageLanguage');
        this.user = JSON.parse(user);

        this.isOpenedLotteries = false;
        this.isOpenedMyAcccount = false;
        this.isOpenedSupport = false;
        this.isOpenedLanguages = false;

      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd), map((event: any) => event.url), )
        .subscribe((event) => {
            this.routerForNavbar = this.router.url.substring(4).replace('/', ' ');
          this.openedBool = false;
        });
        this.showLang = localStorage.getItem('pageLanguage');

        /* loggedIn observer: */
        setInterval(() => {
            if (localStorage.getItem('playerDetails') !== undefined && localStorage.getItem('playerDetails') !== null) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        }, 200);

        if (!this.showLang) {
          setTimeout(() => {
            this.showLang = localStorage.getItem('pageLanguage');
            this.language = localStorage.getItem('pageLanguage');
          }, 2000);
        }

        const sendData = {};
        if (this.user) {
            sendData['sessionId'] = this.user.sessionId;
            sendData['filterType'] = 'all';

            this.lotteryService.postData
            (globals.appDomain + '/products/get/' + this.user.memberId + '/productsGet.json',
                this.lotteryService.getFormUrlEncoded(sendData))
                .subscribe(
                    result => {
                        this.entriesLenght = 0;
                        if (result.message) {
                            if (result.message.message) {
                                const res = result.message.message;
                                res.forEach((content) => {
                                    if (content.Packages) {
                                        content.Packages.forEach((cont) => {
                                            if (cont.Items) {
                                                cont.Items.forEach((con) => {
                                                    if (con.Draw) {
                                                        con.Draw.forEach(() => {
                                                            this.entriesLenght++;
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            } else {
                                this.entriesLenght = 0;
                            }
                        }
                    }
                );

            const sendData1 = {};
            sendData1['sessionId'] = this.user.sessionId;
            sendData1['type'] = 1;

            this.lotteryService.postData(globals.appDomain + '/scratchCards/myEntries/' + this.user.memberId +
                '/result.json', this.lotteryService.getFormUrlEncoded(sendData1)).subscribe(
                result => {
                    if (result && result.length >= 0) {
                        this.countPlayNow = result.length;
                    }
                },
                (e) => {
                },
                () => {
                    sendData1['type'] = 0;
                    this.lotteryService.postData(globals.appDomain + '/scratchCards/myEntries/' + this.user.memberId +
                        '/result.json', this.lotteryService.getFormUrlEncoded(sendData1)).subscribe(
                        result => {
                            if (result && result.length >= 0) {
                                this.updateEntries(result.length + this.countPlayNow);
                            }
                        });
                });
        }
        this.sortValues = [{
            selectDisplayName: 'English',
            selectValue: 'en',
            selectImageClass: 'en'
        }, {
            selectDisplayName: 'German',
            selectValue: 'de',
            selectImageClass: 'de'
        }];

        this.waitForLanguage();

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            if (this.translate.currentLang === 'en') {
                this.selected_method_show_name = {
                    selectDisplayName: 'English',
                    selectValue: 'en',
                    selectImageClass: 'en'
                };
                this.language = 'en';

            } else if (this.translate.currentLang === 'de') {
                this.selected_method_show_name = {
                    selectDisplayName: 'German',
                    selectValue: 'de',
                    selectImageClass: 'de'
                };
                this.language = 'de';
            }

        });
    }
    displayChanger(event) {}
    ngOnDestroy() {
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
    }

    waitForLanguage() {
        if (this.languageService.selectedLanguage === 'en') {
            this.selected_method_show_name = {
                selectDisplayName: 'English',
                selectValue: 'en',
                selectImageClass: 'en'
            };
            this.languageSwitcherReadyToShowMobile = true;

        } else if (this.languageService.selectedLanguage === 'de') {
            this.selected_method_show_name = {
                selectDisplayName: 'German',
                selectValue: 'de',
                selectImageClass: 'de'
            };
            this.languageSwitcherReadyToShowMobile = true;
        } else {
            setTimeout(() => {
                this.waitForLanguage();
            }, 250);
        }
    }

    updateEntries(length) {
        if (this.entriesLenght >= 0) {
            this.entriesLenght += length;
        } else {
            setTimeout(() => {
                this.updateEntries(length);
            }, 500);
        }
    }

    waitForCC() {
        if ( this.countryCode !== null ) {
            this.getData();
        } else {
            setTimeout(() => {
                this.countryCode = localStorage.getItem('country');
                this.waitForCC();
            }, 1000);
        }
    }

    runBurger() {
        this.openedBool = !this.openedBool;
        this.showLang = localStorage.getItem('pageLanguage');
        this.language = this.showLang;
    }
    getData() {
        this.checkForIncomingDraws();
            this.lotteryService.getLotteries(globals.appDomain + '/draws/getAllBundlesOffer/result.json')
              .subscribe(
                result => {
                  result.forEach (( elem) => {
                    if (elem.lotteryName === 'Powerball') {
                      this.powerballBundle.push(elem);
                    } else if (elem.lotteryName === 'EU Millions') {
                      this.euromillionsBundle.push(elem);
                    } else if (elem.lotteryName === 'MegaMillions') {
                      this.megamillionsBundle.push(elem);
                    } else if (elem.lotteryName === 'EuroJackpot') {
                      this.eurojackpotBundle.push(elem);
                    } else if (elem.lotteryName === '6aus49') {
                        this.a6aus49Bundle.push(elem);
                    }
                  });
                }
              );
    }


    checkForIncomingDraws() {
        if (this.incomingDrawsService.incomingDraws) {
            this.getRestLotteries(this.incomingDrawsService.incomingDraws);
        } else {
            setTimeout(() => {
                this.checkForIncomingDraws();
            }, 400);
        }
    }

    getRestLotteries(result) {
            if (result.apiErrorMessage) {
                this.showOffers = false;
            } else {
                this.showOffers = true;
                this.lotteries = result;
                this.restLotteries = [];
                for (const i in this.lotteries) {
                    if (this.lotteries[i].LotteryName !== 'Powerball' &&
                        this.lotteries[i].LotteryName !== 'EU Millions' &&
                        this.lotteries[i].LotteryName !== 'Winner' &&
                        this.lotteries[i].LotteryName !== 'Winaija Lotto' &&
                        this.lotteries[i].LotteryName !== 'EuroJackpot') {
                        this.restLotteries.push(this.lotteries[i]);
                    } else if (this.lotteries[i].LotteryName === 'Powerball') {
                        this.powerball.push(this.lotteries[i]);
                    } else if (this.lotteries[i].LotteryName === 'EuroJackpot') {
                        this.eurojackpot.push(this.lotteries[i]);
                    } else if (this.lotteries[i].LotteryName === 'EU Millions') {
                        this.euromillions.push(this.lotteries[i]);
                    } else if (this.lotteries[i].LotteryName === 'Winner') {
                      this.winner.push(this.lotteries[i]);
                    } else if (this.lotteries[i].LotteryName === 'Winaija Lotto') {
                      this.winaijalotto.push(this.lotteries[i]);
                    }
                }
                this.showOffers = true;
                this.restLotteries = this.restLotteries.slice(0, 6);
            }

    }




    getResults() {
        this.lotteryService.getLotteries
        (globals.appDomain + '/draws/lastLotteryResult/response.html')
            .subscribe(
                result => {
                    const results = result;
                    for ( const i in results) {
                        if ( results[i].LotteryName === 'Powerball') {
                            this.powerballLast.push(results[i]);
                        } else if ( results[i].LotteryName === 'EU Millions') {
                            this.euromillionsLast.push(results[i]);
                        } else if ( results[i].LotteryName === 'MegaMillions' ) {
                            this.megamillionsLast.push(results[i]);
                        } else if ( results[i].LotteryName === 'EuroJackpot') {
                            this.eurojackpotLast.push(results[i]);
                        } else if (results[i].LotteryName === '6aus49') {
                            this.a6aus49Last.push(results[i]);
                        }
                    }
                }
            );
    }

    buyPackage(id, url, lotteryName, entries, price, packageId, name) {
        this.isLoadingButtonName = name;
        let memberId = '';
        let sessionId = '';
        if ( this.user !== null && this.user !== undefined) {
            sessionId = this.user.sessionId;
            memberId = this.user.memberId;
        } else {
            sessionId = 'false';
            memberId = 'false';
        }

      const sendData = {};
      sendData['lotteryLink'] = url;
      sendData['lotteryId'] = id;
      sendData['numberOfEntries'] = entries;
      sendData['lotteryName'] = lotteryName;
      sendData['lotteryItemPrice'] = price;
      sendData['drawCount'] = 1;
      sendData['billingPeriod'] = 0;
      sendData['isSubscription'] = 0;
      sendData['packageId'] = packageId;
      sendData['name'] = name;
      sendData['sessionId'] = sessionId;
      sendData['memberId'] = memberId;

        this.lotteryService.postData
        (globals.appDomain + '/cart/makeBundle/response.html', this.lotteryService.getFormUrlEncoded(sendData)
        )
            .subscribe(
                result => {
                    const addToCartItem = result.message;
                    const currentCart = localStorage.getItem('cart');
                    if (currentCart !== null && currentCart !== undefined) {
                        const jsonCart = JSON.parse(currentCart);
                        jsonCart.push(addToCartItem);
                        localStorage.setItem('cart', JSON.stringify(jsonCart));
                    } else {
                        const cartArray = [];
                        cartArray.push(addToCartItem);
                        localStorage.setItem('cart', JSON.stringify(cartArray));
                    }
                  this.router.navigate(['/' + this.showLang, 'cart']);
                }
            );
    }
  formatDate(obj) {
    return obj.toString().replace(/\s/g, 'T');
  }


  activeRouteParameters(routename: string, routename_two: string): boolean {
    return this.router.url.indexOf(routename) > -1 || this.router.url.indexOf(routename_two) > -1;
  }

  activeRoute(routename: string): boolean {
      return (this.router.url.indexOf(routename) > -1
          && this.router.url.indexOf('powerball') === -1
          && this.router.url.indexOf('eumillions') === -1
          && this.router.url.indexOf('eurojackpot') === -1
          && this.router.url.indexOf('megamillions') === -1
          && this.router.url.indexOf('a6aus49') === -1
          && this.router.url.indexOf('lotteries-results') === -1);
  }

  activeRouteAllResults(routename: string): boolean {
    return (this.router.url === '/' + routename
      && this.router.url.indexOf('powerball') === -1
      && this.router.url.indexOf('eumillions') === -1
      && this.router.url.indexOf('eurojackpot') === -1
      && this.router.url.indexOf('megamillions') === -1
      && this.router.url.indexOf('a6aus49') === -1
      || this.router.url.indexOf('/' + routename + '/') > -1
      && this.router.url.indexOf('powerball') === -1
      && this.router.url.indexOf('eumillions') === -1
      && this.router.url.indexOf('eurojackpot') === -1
      && this.router.url.indexOf('a6aus49') === -1
      && this.router.url.indexOf('megamillions') === -1);
  }

  hiddenMoreLotteries() {
    this.isClassVisible = true;
    setTimeout(() => {
      this.isClassVisible = false;
    }, 1000);
  }

    switchLanguage(event) {
        if (event && event.selectValue) {
            const language = event.selectValue;
            if (language !== undefined) {
                this.translate.use(language);
                this.language = language;
                localStorage.setItem('pageLanguage', language);
                if (this.router.url.indexOf('/en') > -1 || this.router.url.indexOf('/de') > -1) {
                    if (this.router.url.indexOf('/en') > -1 && this.language !== 'en') {
                        this.router.navigateByUrl(this.router.url.replace('/en', '/de'));
                    } else if (this.router.url.indexOf('/de') > -1 && this.language !== 'de') {
                        this.router.navigateByUrl(this.router.url.replace('/de', '/en'));
                    }
                }
            }
        }
    }

  logOut(event) {
      if (event !== undefined) {
          event.preventDefault();
      }
      this.closeBurgerMenu();
      this.loggedIn = this.userService.logOut();

  }

  goToDashboard(val) {
    this.router.navigate(['/' + this.showLang, 'dashboard']);
    localStorage.setItem('dashboardStatus', val);

    this.closeBurgerMenu();
  }
    goToLotteries() {
        this.isOpenedLotteries = false;
        this.router.navigate(['/' + this.showLang, 'lotteries']);
        setTimeout(() => {
            this.isOpenedLotteries = false;
        }, 500);
        this.closeBurgerMenu();
    }

  closeBurgerMenu () {
    this.openedBool = false;
  }

    languageEmit(lang) {
        this.subscriptionsService.emitLanguage(lang);
    }

  openSubMenu(type) {
      if (type === 'lotteries') {
        this.isOpenedLotteries = !this.isOpenedLotteries;
      }  else if (type === 'acc') {
        this.isOpenedMyAcccount = !this.isOpenedMyAcccount;
      } else if (type === 'support') {
        this.isOpenedSupport = !this.isOpenedSupport;
      } else if (type === 'ln') {
        this.isOpenedLanguages = !this.isOpenedLanguages;
      }
  }

  isActiveMenu(routenameArr) {
    for (let i = 0; i < routenameArr.length; i++) {
      return this.router.url.indexOf(routenameArr[i]) > -1;
    }
  }

  goHome () {
    this.router.navigate(['/']);
    this.openedBool = false;
    this.isOpenedLotteries = false;
    this.isOpenedMyAcccount = false;
    this.isOpenedSupport = false;
    this.isOpenedLanguages = false;
  }
}
